import {gsap, ScrollTrigger} from "../LibrariesImport";
export default class SubNav {
	constructor() {

		this.subNavs = document.querySelectorAll(".single-program-subnav a");
		if( this.subNavs ){

			this.blockAnchor = document.querySelectorAll(".block-anchor");
			this.blockAnchor.forEach( (block, index) => {
				let id = block.id;
				let navTarget = document.querySelector(".single-program-subnav a[href='#"+id+"']");
				ScrollTrigger.create({
					trigger: block,
					start : "top bottom",
					endTrigger: this.blockAnchor[index+1] ?? ".block-gravity-form",
					end: "top bottom",
					toggleClass: {
						targets: navTarget,
						className: "active"
					}
				});
			});

		}

	}

}
